export const de = {
  recently_used: 'Zuletzt benutzt',
  smileys_emotion: 'Smileys & Emotion',
  people_body: 'Personen & Körper',
  animals_nature: 'Tiere & Natur',
  food_drink: 'Essen & Trinken',
  travel_places: 'Reisen & Orte',
  activities: 'Aktivitäten',
  objects: 'Objekte',
  symbols: 'Symbole',
  flags: 'Flaggen',
  search: 'Suche'
};
export default de;
//# sourceMappingURL=de.js.map